<div class="logo">
  <!-- <a [routerLink]="['/']" class="simple-text logo-mini">
        <div class="logo-img">
            <img src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/images/logo.png" />
        </div>
    </a> -->
  <a href="/" class="text-center simple-text logo-normal">
    <img style="max-height:70px" src="https://polen.com.br/content/v6/images/logo-polen-horizontal.svg"
      alt="Gestão de Impacto Social e Transparência" />
  </a>
  <br>
  <!-- <small>{{storeName}}</small> -->
  <!-- <div *ngIf="storeList != null && storeIdSelected != null">
        <select class="form-control" style="background: white;padding: 0 25px;margin-top: 10px;" #storeNewSelect
            [(ngModel)]="storeIdSelected" (change)="changeStore(storeNewSelect.value, storeNewSelect)">
            <option *ngFor="let s of storeList" [value]="s.storeId" [attr.selected]="s.storeId == storeIdSelected">
                {{s.storeName}}
            </option>
        </select>
    </div> -->
  <!-- <small>
            <div class="dropdown">
                <button class="btn btn-block dropdown-toggle" data-toggle="dropdown">
                    {{storeName}}
                    <b class="caret"></b>
                </button>
                <ul class="dropdown-menu">
                    <li><a href="#">Action</a></li>
                    <li><a href="#">Another action</a></li>
                    <li><a href="#">Something else here</a></li>
                    <li class="divider"></li>
                    <li><a href="#">Separated link</a></li>
                    <li class="divider"></li>
                    <li><a href="#">One more separated link</a></li>
                </ul>
            </div>
        </small> -->
</div>
<div class="navbar-minimize">
  <button id="minimizeSidebar" class="btn btn-fill btn-icon">
    <svg class="new-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
      stroke="#423b79" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  </button>
</div>
<div class="sidebar-wrapper">
  <ng-container *ngIf="!isAdminView">
    <!-- <ng-container *ngIf="customization != null && customization == 'trocosimples'"></ng-container> -->
    <ng-container *ngIf="!normalMenu">
      <ul class="nav">
        <li routerLinkActive="active" *ngFor="let menuitem of menuItems">
          <!--If is a single link-->
          <a [routerLink]="[menuitem.path]" [queryParams]="{show:'direct'}" *ngIf="menuitem.type === 'link'">
            <img class="ti-layout" *ngIf="menuitem.iconimg" src="{{menuitem.iconimg}}" style="
                        width: 32px;
                        float: left;
                        font-size: 24px;
                        float: left;
                        margin-right: 15px;
                        line-height: 30px;
                        width: 30px;
                        text-align: center;
                    " />
            <i *ngIf="menuitem.icontype" class="{{menuitem.icontype}}"></i>
            <p>{{menuitem.title}}</p>
          </a>
          <a [href]="menuitem.path" target="_blank" *ngIf="menuitem.type === 'external'">
            <img class="ti-layout" *ngIf="menuitem.iconimg" src="{{menuitem.iconimg}}" style="
                    width: 32px;
                    float: left;
                    font-size: 24px;
                    float: left;
                    margin-right: 15px;
                    line-height: 30px;
                    width: 30px;
                    text-align: center;
                " />
            <i *ngIf="menuitem.icontype" class="{{menuitem.icontype}}"></i>
            <p>{{menuitem.title}}</p>
          </a>
          <a (click)="redirectMenu(menuitem.path)" target="_blank" *ngIf="menuitem.type === 'method'"
            style="cursor:pointer">
            <img class="ti-layout" *ngIf="menuitem.iconimg" src="{{menuitem.iconimg}}" style="
                    width: 32px;
                    float: left;
                    font-size: 24px;
                    float: left;
                    margin-right: 15px;
                    line-height: 30px;
                    width: 30px;
                    text-align: center;
                " />
            <i *ngIf="menuitem.icontype" class="{{menuitem.icontype}}"></i>
            <p>{{menuitem.title}}</p>
          </a>
          <!--If it have a submenu-->
          <a data-toggle="collapse" href="#{{menuitem.title}}" *ngIf="menuitem.type === 'sub'">
            <i class="{{menuitem.icontype}}"></i>
            <p>{{menuitem.title}}
              <b class="caret"></b>
            </p>
          </a>
          <!--Display the submenu items-->
          <div id="{{menuitem.title}}" class="collapse" *ngIf="menuitem.type === 'sub'">
            <ul class="nav">
              <li routerLinkActive="active" *ngFor="let childitem of menuitem.children">
                <a [routerLink]="[menuitem.path, childitem.path]">
                  <span class="sidebar-mini">{{childitem.ab}}</span>
                  <span class="sidebar-normal">{{childitem.title}}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </ng-container>
    <ng-container *ngIf="normalMenu">
      <ul class="nav">
        <li>
          <a href="#/profile/onboarding" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/pagina-inicial.svg">
            <p>Página Inicial</p>
          </a>
        </li>
      </ul>
      <div class="header-menu">Financeiro</div>
      <ul class="nav">
        <li>
          <a href="#/transactions" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/compras-doacoes.svg">
            <p>Compras &amp; Doações </p>
          </a>
        </li>
        <li style="margin-top: 5px;">
          <a href="#/profile/invoices" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" style="
            width: 19px !important;
            margin-left: 6px;" src="../../assets/img/icon/white-theme/faturas.svg">
            <p>Faturas</p>
          </a>
        </li>
      </ul>
      <div class="header-menu">Configurações</div>
      <ul class="nav">
        <li>
          <a href="#/profile/solutions" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/solucoes.svg">
            <p>Soluções</p>
          </a>
        </li>
        <li>
          <a href="#/transparency" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/transparencia.svg">
            <p>Transparência</p>
          </a>
        </li>
        <li>
          <a href="#/customization" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/caixinha-doacao.svg">
            <p>Caixinha de doação</p>
          </a>
        </li>
        <li *ngIf="canMakeCampain">
          <a href="/#/campaign/list?show=direct" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/tela-de-arrecadacao.svg">
            <p>Tela de Arrecadação</p>
          </a>
        </li>
        <!-- <li>         
    <a href="#/matchfunding" (click)="changeActiveActualItem($event)">
       <img class="ti-layout" src="../../assets/img/icon/white-theme/matchfunding.svg">
       <p>Matchfunding</p>
    </a>          
 </li> -->
        <li>
          <a href="#/compredoe" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/quem-transforma.svg">
            <p>Selo Quem Transforma</p>
          </a>
        </li>
      </ul>
      <div class="header-menu">Métricas e Números</div>
      <ul class="nav">
        <li>
          <a href="#/profile/overview" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/analytics.svg">
            <p>Analytics</p>
          </a>
        </li>
        <li>
          <a href="#/ngo/supportedNgos" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/nosso-impacto.svg">
            <p>Nosso Impacto</p>
          </a>
        </li>
      </ul>
      <div class="header-menu">Compartilhamento e mais</div>
      <ul class="nav">
        <li>
          <a href="#/ngo/storescontent" (click)="changeActiveActualItem($event)">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/conteudo-impacto.svg">
            <p>Conteúdo de Impacto</p>
          </a>
        </li>
        <li>
          <a style="cursor:pointer" target="_blank" href="https://marketing.polen.com.br/">
            <img class="ti-layout" src="../../assets/img/icon/white-theme/marketing-causas.svg">
            <p>Marketing de Causas</p>
          </a>
        </li>
      </ul>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="isAdminView">
    <ul class="nav">
      <li routerLinkActive="active" *ngFor="let menuitem of menuItems">
        <!--If is a single link-->
        <a [routerLink]="[menuitem.path]" [queryParams]="{show:'direct'}" *ngIf="menuitem.type === 'link'">
          <img class="ti-layout" *ngIf="menuitem.iconimg" src="{{menuitem.iconimg}}" style="
                      width: 32px;
                      float: left;
                      font-size: 24px;
                      float: left;
                      margin-right: 15px;
                      line-height: 30px;
                      width: 30px;
                      text-align: center;
                  " />
          <i *ngIf="menuitem.icontype" class="{{menuitem.icontype}}"></i>
          <p>{{menuitem.title}}</p>
        </a>
        <a [href]="menuitem.path" target="_blank" *ngIf="menuitem.type === 'external'">
          <img class="ti-layout" *ngIf="menuitem.iconimg" src="{{menuitem.iconimg}}" style="
                  width: 32px;
                  float: left;
                  font-size: 24px;
                  float: left;
                  margin-right: 15px;
                  line-height: 30px;
                  width: 30px;
                  text-align: center;
              " />
          <i *ngIf="menuitem.icontype" class="{{menuitem.icontype}}"></i>
          <p>{{menuitem.title}}</p>
        </a>
        <a (click)="redirectMenu(menuitem.path)" target="_blank" *ngIf="menuitem.type === 'method'"
          style="cursor:pointer">
          <img class="ti-layout" *ngIf="menuitem.iconimg" src="{{menuitem.iconimg}}" style="
                  width: 32px;
                  float: left;
                  font-size: 24px;
                  float: left;
                  margin-right: 15px;
                  line-height: 30px;
                  width: 30px;
                  text-align: center;
              " />
          <i *ngIf="menuitem.icontype" class="{{menuitem.icontype}}"></i>
          <p>{{menuitem.title}}</p>
        </a>
        <!--If it have a submenu-->
        <a data-toggle="collapse" href="#{{menuitem.title}}" *ngIf="menuitem.type === 'sub'">
          <i class="{{menuitem.icontype}}"></i>
          <p>{{menuitem.title}}
            <b class="caret"></b>
          </p>
        </a>
        <!--Display the submenu items-->
        <div id="{{menuitem.title}}" class="collapse" *ngIf="menuitem.type === 'sub'">
          <ul class="nav">
            <li routerLinkActive="active" *ngFor="let childitem of menuitem.children">
              <a [routerLink]="[menuitem.path, childitem.path]">
                <span class="sidebar-mini">{{childitem.ab}}</span>
                <span class="sidebar-normal">{{childitem.title}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li *ngIf="storePlatform != null && storePlatform.indexOf('loja-integrada') >= 0" routerLinkActive="active">
        <!--If is a single link-->
        <!-- <a href="/#/onboarding">  -->
        <a data-toggle="waring"
          title="A integração BomTroco com a Loja Integrada está indisponível no momento. Entre em contato com nosso suporte"
          (click)="warningAlert()">
          <i class="ti-gift"></i>
          <p>BomTroco</p>
        </a>
      </li>
    </ul>
  </ng-container>
</div>

<div class="fixed-plan" *ngIf="profilePlan != null && (profilePlan.planSeoName == 'free') && hasPlatform">

  <div class="plan-header">Plano {{ profilePlan.planName }}</div>
  <div class="plan-content">
    <div class="item-orders">
      <div class="item-orders-label">
        <img class="ti-layout" src="../../assets/img/icon/white-theme/compras-doacoes.svg">
        <p style="margin-top: 12%;">Pedidos contabilizados</p>
      </div>
      <div class="item-orders-value" *ngIf="profilePlan != null">
        {{profilePlan.orderConsume}}/{{profilePlan.orderMaxPlan}}
      </div>
    </div>

    <div class="info-progress-bar">
      <div class="progress-bar-container">
        <div class="progress-bar-match-funding" [ngStyle]="{'width':percentageUsed+'%'}"></div>
      </div>
    </div>
    
    <div class="item-orders">
      <div class="item-orders-label">
        <img class="ti-layout" style=" width: 14px !important; " src="../../assets/img/icon/credito.svg" />
        <p style="margin-top: 8%;">Saldo disponível: </p>
      </div>
      <div class="item-orders-value">
        R$ {{ profilePlan.availableBalance | number: '.2-2'}}
      </div>
    </div>
  </div>
  <div class="plan-bottom">
    <a *ngIf="profilePlan.availableBalance < profilePlan.minimumDonation && !profilePlan.hasPendingInvoice" class="btn btn-secondary btn-fill hireButton" href="/#/profile/balance">ADICIONAR CRÉDITOS</a>
    <a *ngIf="profilePlan.hasPendingInvoice" target="_blank" class="btn btn-secondary btn-fill hireButton" href="/#/fatura/{{profilePlan.pendingInvoiceId}}">Pagar Recarga de Saldo</a>
    <a *ngIf="profilePlan.availableBalance > profilePlan.minimumDonation && !profilePlan.hasPendingInvoice" class="btn btn-secondary btn-fill hireButton" href="/#/profile/plans">MELHORAR MEU PLANO</a>
    
  </div>
</div>

<div class="fixed-plan" *ngIf="profilePlan != null && (profilePlan.planSeoName == 'trial') && hasPlatform">
  <div class="plan-header">{{ profilePlan.planName }}</div>
  <div class="plan-content"  style="margin-bottom: 10px;">
    <div class="info-progress-bar">
      <p *ngIf="profilePlan.trialDaysLeft >= 0"><span class="value-progress-bar" >{{profilePlan.trialDaysLeft}}</span> dias restantes</p>
      <p *ngIf="profilePlan.trialDaysLeft < 0"><span class="value-progress-bar" >0</span> dias restantes</p>
      <div class="progress-bar-container">
        <div class="progress-bar-match-funding" [ngStyle]="{'width':percentageDays+'%'}"></div>
      </div>
    </div>
  </div>
  <div class="plan-bottom">
    <small style="color: #4cae4c;">Contrate um plano Polen antecipado e garanta até 20% de desconto!</small>
    <a class="btn btn-secondary btn-fill upgradeButton" href="/#/profile/plans">Selecionar Plano</a>
  </div>
</div>